import { useContext } from 'react';
import ProjectsContext from '../contexts/Projects';

export default () => {
    const context = useContext(ProjectsContext);

    return context;
};
